import { useMemo } from 'react';
import { useStore } from 'store/store';
import { GetUserProfileResponse, useUtxUsersGetUserProfile } from '../../../../../packages/utx-client/src/react';

export interface UseGetUserProp {
  profileData: GetUserProfileResponse | undefined;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useGetUser = (): UseGetUserProp => {
  const store = useStore();

  // GET User profile
  const queryProfile = useUtxUsersGetUserProfile({
    axios: {
      headers: {
        Authorization: `Bearer ${store.authToken}`
      }
    }
  });

  const profileData = useMemo(() => {
    const data = queryProfile.data?.data;
    return data;
  }, [queryProfile.data?.data]);

  const isLoading = useMemo(() => {
    return queryProfile.isLoading;
  }, [queryProfile.isLoading]);

  const isSuccess = useMemo(() => {
    return queryProfile.isSuccess;
  }, [queryProfile.isSuccess]);

  return {
    profileData,
    isLoading,
    isSuccess
  };
};
